import { VideoTranscript } from './videoTranscript';

export type PlaylistFormData = {
  format: string,
  type: number,
  isActive: boolean,
  isRandomize: boolean,
  name: string | null,
  mrssPassword: string | null,
  mrssUrl: string | null,
  mrssUsername: string | null,
  orgId: number | null,
  refreshRateInMins: number,
  uuid: string | null,
  iabCategories: string[],
  trendCategories: number[],
  iabCategoriesExclude: boolean,
  playlistPublisher: string[],
  playlistPublisherExclude: boolean,
  geoCountries: number[],
  geoCountriesExclude: boolean,
  enableNotification: boolean,
  emailAddress: string[],
  dailyNotificationAtHour: number | null,
  maxVideoApproved: number,
  publisherRightsholderIds: number[],
  asaApproved: boolean;
}

export type PlaylistAPIData = {
  format: string,
  playlist_type_id: number,
  playlist_type_name?: string,
  is_active: boolean,
  is_randomize: boolean,
  name: string | null,
  mrss_password: string | null,
  mrss_url: string | null,
  mrss_username: string | null,
  org_id: number | null,
  refresh_rate_in_mins: number,
  last_refreshed: string,
  uuid: string | null,
  iab_categories: string[],
  iab_categories_exclude: boolean,
  keyword_trend_category_id: number[],
  playlist_publisher: number[],
  playlist_publisher_exclude: boolean,
  playlist_geo_country: number[],
  playlist_geo_country_exclude: boolean
  play_count: number
  video_count: number
  first_video_thumbnail: string
  playlist_geo_country_name: string[]
  iab_category_names: string[]
  playlist_publisher_name: string[],
  organisation: string
  notification_email_target: string[]
  enabled_email_notification: boolean;
  notification_daily_at_hour: number;
  has_preroll_assigned: boolean,
  max_approved_videos: number,
  publisher_rightsholder_ids: number[]
  asa_approved: boolean;
}

export type IABCategory = {
  id: string;
  name: string;
  parent: string;
  level: number;
}

export type TrendCategory = {
  id: number;
  name: string;
}


export type PlaylistRightsholder = {
  id: number;
  name: string;
}

export type PlaylistPublisherRightsholder = {
  id: number;
  domain: string;
  format: string;
}

export interface PlaylistVideo {
  id: number;
  video_thumbnail: string;
  video_publish_date: Date;
  video_title: string;
  video_title_translated: string;
  video_rightsholder: string;
  video_format: string;
  video_summary: string;
  is_manually_added: boolean;
  video_duration: number;
  article_title: string;
  video_id: string;
  video_producer: string;
  video_type: string;
  article_thumbnail: string;
  article_thumb: string;
  article_publish_date: Date;
  record_inserted_at: Date;
  has_trending_matched: boolean;
  video_play_count: number;
  lang: string;
  pos: number;
  total_page_views: number;
  transcript?: string;
  is_opus: boolean;
  parent_media_id: string;
  parent_title: string;
  parent_title_translated: string;
  can_manage_video: boolean;
  ad_break_type: string;
  ad_break_skippable: boolean;
  skip_custom_caption: boolean;
  transcripts: VideoTranscript[],
  uuid: string
  video_disable_custom_caption: boolean
  opus_title: string,
  opus_description: string,
  opus_clip_genre: string,
  opus_hashtags: string[],
}

export interface PlaylistCampaignDeliveryArticle {
  count: number;
  page_url: string
}

export interface PlaylistTrendingItem {
  video_thumbnail: string;
  video_title: string;
  video_rightsholder: string;
  article_thumb: string;
  record_inserted_at: number;
  event_count: number;
  headline_translated: string;
  article_id: string;
  has_video_matched: boolean;
  video_id: string;
  article_thumbnail: string;
  article_title: string;
  video_type: string;
  parent_media_id: string;
  parent_title: string;
  parent_title_translated: string;
  video_publish_start_date: number;
  format: string;
  article_publish_date: number;
  matched_score_percentage: number;
  is_trending: boolean;
  web_url: string;
  organisation_origin: string;
  horizontal_matched: Record<string, any>;
  opus_clip_id: string;
  video_summary: string;
  uuid: string;
  opus_title: string,
  opus_description: string,
  opus_clip_genre: string,
  opus_hashtags: string[],
}

export type PlayerType = 'editorial' | 'branded'

export interface CreativeTagState {
  id?: number,
  playlist_player_id: number,
  name: string,
  dsp_name: string
  tag: string
}

export interface DealState {
  id?: number;
  playlist_creative_tag_id: number;
  segments: string[],
  geos: string[],
  deal_id: string,
  ssp: string
}

export interface PlayerState {
  ad_unit: string,
  click_thru_on_tray_only: boolean,
  click_thru_url: string,
  enabled_tray: boolean,
  end_slate_image_filename?: string,
  id: number | undefined,
  impression_url: string,
  impression_url2: string,
  name: string,
  player_id: string,
  playlist_uuid: string,
  tray_image_filename?: string
  lumen_id: string
  video_size: number,
  tray_colour: string,
  type: PlayerType
  impression_trackers: { url: string, tag: string, event: string}[]
  lumen_trackers: { type: string, mid: string }[]
}

export enum PLAYLIST_TYPES {
  DEEP_MATCH = 1,
  MANUAL = 2,
  MRSS = 3,
  TREND_MATCH = 4,
}